import { render, staticRenderFns } from "./base_delete.vue?vue&type=template&id=4213db86&scoped=true&"
import script from "./base_delete.vue?vue&type=script&lang=js&"
export * from "./base_delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4213db86",
  null
  
)

export default component.exports